import { render, staticRenderFns } from "./b6.vue?vue&type=template&id=324f7ed9&scoped=true"
import script from "./b6.vue?vue&type=script&lang=js"
export * from "./b6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324f7ed9",
  null
  
)

export default component.exports